import React from 'react';
import moment from 'moment';
import './index.css';

class TimePicker extends React.Component {
  constructor (props){
    super(props);
    let time = ['8:00 am', '9:00 am', '10:00 am', '11:00 am', '12:00 pm', '13:00 pm', '14:00 pm', '15:00 pm', '16:00 pm', '17:00 pm', '18:00 pm', '19:00 pm', '20:00 pm'];
    let index = time.findIndex((el) => {
      return el == moment().format('HH:00 a');
    })
    this.showTimeSelect = time.splice(index, time.length);
    let cureentSelectedTime = this.props.selectedTime;
    this.cureentSelectedIndex = this.showTimeSelect.findIndex((el) => {
      return el == cureentSelectedTime;
    })
  }
  handlerSelectTime = (selected) => {
    this.props.forSave(selected);
  }
  render() {
    return (
        <ul className="time-picker">
            {this.showTimeSelect.map((time, index) => {
              return <li key={index} className={this.cureentSelectedIndex == index ? 'time-picker__item-active' : null} onClick={this.handlerSelectTime.bind(this, time)}>{time}</li>;
            })}
        </ul>
    );
  }
}

export default TimePicker;
